import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

// Animation for the toast notification to slide down and fade in
const slideInDown = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

// Animation for the toast notification to slide up and fade out
const slideOutUp = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
`;

// Styled container for the popup notification
const PopupContainer = styled.div`
  position: fixed;
  top: 80px; /* Position below the header */
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: fit-content; /* Adjust width to content */
  z-index: 10000; /* Ensure it's above everything */
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 300px;
  max-width: 450px;
  padding: 12px 20px;
  background-color: rgba(34, 197, 94, 0.9);
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(34, 197, 94, 0.3);
  animation: ${(props) => (props.exiting ? slideOutUp : slideInDown)} 0.4s
    ease-out forwards;
  font-weight: 500;
  text-align: center;

  @media (max-width: 480px) {
    width: 90%;
    min-width: auto;
  }
`;

// Icon component for success checkmark
const Icon = styled.span`
  margin-right: 12px;
  font-size: 20px;
`;

/**
 * SuccessPopup component
 * Displays a green toast notification that appears at the top center of the screen
 */
const SuccessPopup = ({ message, title, duration = 3000, onClose }) => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setExiting(true);
      // Allow time for exit animation before removing from DOM
      setTimeout(() => {
        if (onClose) onClose();
      }, 400);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <PopupContainer exiting={exiting}>
      <Icon>✓</Icon>
      {title && title}
      {title && message && " - "}
      {message}
    </PopupContainer>
  );
};

export default SuccessPopup;
